import React, { useRef, useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useBreakpoint from 'hooks/useBreakpoint';
import { SITE_PLATFORM_MOBILE, SITE_PLATFORM_TABLET } from 'helpers/BreakpointHelper';
import VideoPlayer from 'componentsV2/VideoPlayer';
import Icon from 'components/Icon';
import { noop } from 'helpers/GlobalHelper';
import { VIDEO_TYPE_TRAILER } from 'helpers/ContentHelper';
import { getActivePlayer, getPlayerState } from 'helpers/PlayerHelper';
import { getSessionId } from 'helpers/AuthHelper';
import {
  callSegmentPlayerEvent,
  SegmentPlayerStates,
  SegmentVideoEvents,
} from '@foxcorp/delta-web-analytics';
import { FreemiumContext } from 'index/FreemiumProvider';
import ContextPromo from './ContextPromo';

import Style from './ContextPlayer.module.scss';

const ContextPlayer = ({
  account,
  onClickCTA,
  onClose,
  promo,
  promoDisabled,
  video,
  visibility,
}) => {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === SITE_PLATFORM_MOBILE || breakpoint === SITE_PLATFORM_TABLET;
  const modalRef = useRef();
  const { isFreemium } = useContext(FreemiumContext);
  const {
    upsellPromoNavCTA: PromoCTA,
    upsellPromoNavFreemiumCTA: PromoFreemiumCTA,
  } = window.Language;
  const CTA = isFreemium ? PromoFreemiumCTA : PromoCTA;

  if (!visibility) return null;

  const handleOverlayClick = event => {
    if (modalRef.current.contains(event.target)) {
      return null;
    }
    if (getPlayerState(getActivePlayer()) === 'PLAYING') {
      callSegmentPlayerEvent({
        eventName: SegmentVideoEvents.videoPlaybackInterrupted,
        props: {
          method: 'player closed',
          video_player_state: SegmentPlayerStates.PAUSE,
          auth_token_sid: getSessionId(account?.accessToken),
        },
      });
    }
    onClose();
    return event;
  };
  const modalStyle = classNames(Style.modalOverlay, 'modal-open');
  const renderPromoBanner = () =>
    !isMobile &&
    !promoDisabled && (
      <ContextPromo
        {...promo}
        promoCTA={isFreemium ? CTA : promo.promoCTA || CTA}
        onClickCTA={onClickCTA}
      />
    );
  const renderCTA = () =>
    isMobile &&
    !promoDisabled && (
      <div className={Style.CTA}>
        <button className={Style.btn} onClick={onClickCTA}>
          {isFreemium ? CTA : promo.promoCTA || CTA}
        </button>
      </div>
    );
  return (
    <div className={modalStyle} onClick={handleOverlayClick}>
      <div className={Style.closeButton} onClick={onClose}>
        <Icon icon="close" color="white" size="large" />
      </div>
      <div ref={modalRef} className={Style.modal}>
        <VideoPlayer onPlaybackComplete={onClose} video={video} type={VIDEO_TYPE_TRAILER} />
        {renderPromoBanner()}
        {renderCTA()}
      </div>
    </div>
  );
};

ContextPlayer.defaultProps = {
  isMobile: false,
  onClickCTA: noop,
  onClose: noop,
  promo: {},
  promoDisabled: false,
  video: null,
  visibility: false,
};

ContextPlayer.propTypes = {
  account: PropTypes.shape({}),
  anonymousAccount: PropTypes.shape({}),
  isMobile: PropTypes.bool,
  onClickCTA: PropTypes.func,
  onClose: PropTypes.func,
  promo: PropTypes.shape({}),
  promoDisabled: PropTypes.bool,
  video: PropTypes.shape({}),
  visibility: PropTypes.bool,
};

export default ContextPlayer;
